import { normalizeInviteesResponse } from './normalize_invitees_response'

const isValidInviteeEmail = (email) => {
  if (typeof email !== 'string') return false
  const trimmed = email.trim()
  return trimmed.length > 0 && /@/.test(trimmed)
}

const extractRecipientEmailsFromInvitees = (results) => {
  const seen = new Set()
  const recipients = []

  results.forEach((invitee) => {
    const email = invitee?.email
    if (!isValidInviteeEmail(email)) return

    const normalized = email.trim().toLowerCase()
    if (seen.has(normalized)) return

    seen.add(normalized)
    recipients.push(email.trim())
  })

  return recipients
}

const fetchInviteePages = async ({ trigger, eventId, page, preferCacheValue = false }) => {
  const request = preferCacheValue
    ? trigger({ eventId, page }, true)
    : trigger({ eventId, page })
  const normalized = normalizeInviteesResponse(
    await request.unwrap()
  )

  if (!normalized.pagination.nextPage) {
    return normalized.results
  }

  const remainingInvitees = await fetchInviteePages({
    trigger,
    eventId,
    page: normalized.pagination.currentPage + 1,
  })

  return [...normalized.results, ...remainingInvitees]
}

export const fetchAllInviteesForBulkEmail = async ({ trigger, eventId }) => {
  const invitees = await fetchInviteePages({
    trigger,
    eventId,
    page: 1,
    preferCacheValue: true,
  })

  return extractRecipientEmailsFromInvitees(invitees)
}
